<template>
  <v-app id="portal">
    <v-content class="px-2">
      <titulo-responsivo :titulo="locale[local].screen.denuncia.string001" />
      <v-divider />
      <div v-if="loading" class="d-flex justify-center pt-4">
        <v-card width="1000">
          <v-card-text>
            <v-skeleton-loader
              v-model="loading"
              type="article, article, actions"
            ></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </div>
      <div v-else class="d-flex justify-center pt-4">
        <v-form ref="form">        
          <v-card width="1000">
            <v-card-text>
              <v-row align="center" class="mt-2 mx-2">
                <v-col cols="12">
                  <v-select
                    :rules="[(v) => !!v || 'Preencha o campo']"
                    filled
                    :items="items"
                    item-text="identificacao"
                    item-value="identificacao"
                    dense
                    :label="locale[local].screen.denuncia.string002"
                    v-model="ttDenuncia.identificacao"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    filled
                    v-model="ttDenuncia.nomeVitima"
                    name="input-1-1"
                    :label="locale[local].screen.denuncia.string003"
                    :hint="locale[local].screen.denuncia.string004"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :rules="[(v) => !!v || 'Preencha o campo']"
                    filled
                    v-model="ttDenuncia.nomeOfensor"
                    name="input-1-1"
                    :label="locale[local].screen.denuncia.string005"
                    :hint="locale[local].screen.denuncia.string006"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    :rules="[(v) => !!v || 'Preencha o campo']"
                    filled
                    :items="itemsRelatado"
                    item-text="fatoRelatado"
                    item-value="fatoRelatado"
                    dense
                    :label="locale[local].screen.denuncia.string007"
                    v-model="ttDenuncia.fatoRelatado"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    :rules="[(v) => !!v || 'Preencha o campo']"
                    filled
                    v-model="ttDenuncia.quandoOcorreu"
                    name="input-7-1"
                    :label="locale[local].screen.denuncia.string008"
                    :hint="locale[local].screen.denuncia.string009"
                  ></v-textarea>
                </v-col>
                <v-col cols="4">
                  <v-select
                    :rules="[(v) => !!v || 'Preencha o campo']"
                    filled
                    :items="itemsTestemunha"
                    item-text="testemunha"
                    item-value="testemunha"
                    dense
                    :label="locale[local].screen.denuncia.string010"
                    v-model="temTesmunha"
                  ></v-select>
                </v-col>
                <v-col cols="8" v-show="temTesmunha">
                  <v-text-field
                    filled
                    v-model="ttDenuncia.testemunhas"
                    name="input-1-1"
                    :label="locale[local].screen.denuncia.string011"
                    :hint="locale[local].screen.denuncia.string012"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    :rules="[(v) => !!v || 'Preencha o campo']"
                    filled
                    v-model="ttDenuncia.ocorrido"
                    name="input-7-1"
                    :label="locale[local].screen.denuncia.string013"
                    :hint="locale[local].screen.faleComRH.string014"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-btn class="primary" @click="enviar" :loading="loadingBtn">
                    <v-icon class="pr-2">mdi-send</v-icon>
                    {{ locale[local].screen.faleComRH.string005 }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import Service from "@/components/api/Service";
import { snackbar, alert } from "cids-cgi/lib/util";
import { locale } from "../locale/locale";

export default {
  data: () => ({
    service: new Service(),
    loading: false,
    loadingBtn: false,
    temTesmunha: false,
    itemsTestemunha: [{
        testemunha: "Não"
      },
      {
        testemunha: "Sim"
      }
    ],
    ttDenuncia: {
      identificacao: "",
      nomeVitima: "",
      nomeOfensor: "",
      fatoRelatado: "",
      quandoOcorreu: "",
      testemunhas: "",
      ocorrido: ""}
    ,
    items: [{
      identificacao: "Vítima do Ato"
    },
    {
      identificacao: "Terceiro (a)"
    }],    

    itemsRelatado: [{
      fatoRelatado: "Primeira vez (nunca ocorreu antes)"
    },
    {
      fatoRelatado: "Recorrente (ocorreu outras vezes)"
    }],    
  }),
  async mounted() {
    this.loading = true;
    try {
    } catch (error) {
    } finally {
      this.loading = false;
    }
  },

  methods: {
    async enviar() {
      this.loadingBtn = true;

      try {
        if (this.$refs.form.validate()) {

          const response = await this.service.gravaDenuncia(this.ttDenuncia);

          if (response[0].estatus === "Sucesso") {
            alert.show({ message: locale[window.local].screen.denuncia.string015,
                         color: "green" });
            this.$router.push("/").catch((err) => {
              window.location.reload();
            });
          }
        }
      }
      catch (error) {
        snackbar.show({
          message: "Erro ao gravar Denúncia",
          color: "red",
          timeout: 3000,
        });
      } 
      finally {
        this.loadingBtn = false;        
      }
    },
  },
};
</script>

 